export default class JobSelector {
	constructor(el) {
		if (!el) return;
		this.element = el;
		this.target = document.getElementById('position');
		this.formWrapper = document.getElementById('job-form-wrapper');
		this.events();
	}

	events() {
		this.element.addEventListener('click', (ev) => {
			ev.preventDefault();
			this.target && (this.target.value = this.element.dataset.job);
			if ( window.innerWidth >= 768) {
				this.formWrapper && this.formWrapper.scrollIntoView(false);
			} else {
				this.formWrapper && this.formWrapper.scrollIntoView();
			}
		});
	}
}